/**
 * Updates document head for journal posts so OG / Twitter cards use post data (in-browser).
 * Restores previous values (or removes injected tags) on cleanup.
 * Crawlers use prerendered HTML from `scripts/prerender-blog-seo.mjs` + `build/blog/<slug>/index.html`.
 */

import { buildBlogPostMetaPairs } from './blogPostSeoValues';

/**
 * @param {object} post — row from {@link ./postsMeta.js}
 * @param {object} author — row from {@link ./authors.js}
 * @returns {() => void}
 */
export function applyBlogPostSocialMeta(post, author) {
  const pairs = buildBlogPostMetaPairs(post, author);
  const records = [];

  for (const [attr, key, value] of pairs) {
    const el = document.head.querySelector(`meta[${attr}="${key}"]`);
    const existed = Boolean(el);
    const node = el || document.createElement('meta');
    if (!existed) {
      node.setAttribute(attr, key);
      document.head.appendChild(node);
    }
    const prev = node.getAttribute('content');
    node.setAttribute('content', value);
    records.push({ el: node, prev: prev == null ? '' : prev, existed });
  }

  return () => {
    for (const { el, prev, existed } of records) {
      if (!el?.parentNode) continue;
      if (!existed) {
        el.remove();
      } else {
        el.setAttribute('content', prev);
      }
    }
  };
}
